export const SET_MESSAGE = 'SET_MESSAGE';
export const MESSAGE_POPED = 'MESSAGE_POPED';
export const SET_APP = 'SET_APP';
export const SET_APP_CANCEL_STATUS = 'SET_APP_CANCEL_STATUS';
export const CLOSE_MESSAGE = 'CLOSE_MESSAGE';
export const CREATE_INSTANCE = 'CREATE_INSTANCE';
export const SHOW_MODAL = 'SHOW_MODAL';
export const SHOW_LOGOUT = 'SHOW_LOGOUT';
export const SHOW_LOADER = 'SHOW_LOADER';
export const FRONETEND_PANEL_USER_LOGINED = 'FRONETEND_PANEL_USER_LOGINED';

// DRUG
export const GET_DRUG_IN_DEVICES = 'GET_DRUG_IN_DEVICES';
export const SELECT_DEVICES = 'SELECT_DEVICES';
export const SELECT_DRUG_IN_DEVICES_FROM_SELECTED = 'SELECT_DRUG_IN_DEVICES_FROM_SELECTED';
export const SET_CURRENT_DRUG_BY_INDEX = 'SET_CURRENT_DRUG_BY_INDEX';

// DEVICE
export const RESET_DEVICES_MODULE = 'RESET_DEVICES_MODULE';
export const RESET_EVENT_MODULE = 'RESET_EVENT_MODULE';
export const RESET_DRUG_IN_DEVICE_MODULE = 'RESET_DRUG_IN_DEVICE_MODULE';
export const RESET_DRUG_MODULE = 'RESET_DRUG_MODULE';

export const WEBSOCKET_CONNECT = 'WEBSOCKET_CONNECT';
export const SET_CURRENT_DEVICE_FROM_SELECTED = 'SET_CURRENT_DEVICE_FROM_SELECTED';
export const SET_CURRENT_DEVICE_FROM_ALL = 'SET_CURRENT_DEVICE_FROM_ALL';
export const SET_NEXT_DEVICE = 'SET_NEXT_DEVICE';
export const REMOVE_NEXT_DEVICE = 'REMOVE_NEXT_DEVICE';
export const SETUP_LOCKED_DEVICES = 'SETUP_LOCKED_DEVICES';

// DRUG IN DEVICE
export const SET_CURRENT_DRUG_IN_DEVICE = 'SET_CURRENT_DRUG_IN_DEVICE';
export const SET_NEXT_DRUG_IN_DEVICE = 'SET_NEXT_DRUG_IN_DEVICE';
export const REMOVE_NEXT_DRUG_IN_DEVICE = 'REMOVE_NEXT_DRUG_IN_DEVICE';
export const SET_DRUG_IN_DEVICE_LIST = 'SET_DRUG_IN_DEVICE_LIST'; // this function is not good at all.
export const FILTER_DRUG_IN_DEVICE = 'FILTER_DRUG_IN_DEVICE';
export const SET_SELECTED_DRUG_IN_DEVICE_DIRECTLY = 'SET_SELECTED_DRUG_IN_DEVICE_DIRECTLY';
export const DRUG_IN_DEVICE_USED = 'DRUG_IN_DEVICE_USED';
export const DRUG_STORAGE_EVENT_FIRED = 'DRUG_STORAGE_EVENT_FIRED';
export const SELECT_DRUG_IN_DEVICES_FROM_ALL = 'SELECT_DRUG_IN_DEVICES_FROM_ALL';


export const SET_PROGRESS = 'SET_PROGRESS';
export const TO_NEXT_PROGRESS = 'TO_NEXT_PROGRESS';
export const BACK_PREVIOUS_PROGRESS = 'BACK_PREVIOUS_PROGRESS';
export const SET_CURRENT_STEP = 'SET_CURRENT_STEP';

export const SET_CURRENT_NET = 'SET_CURRENT_NET';
export const SET_CONFIRM_STAGE = 'SET_CONFIRM_STAGE';
export const CHANGE_DEVICE_SELECTED_STATUS = 'CHANGE_DEVICE_SELECTED_STATUS';
export const ADD_DEVICE_TO_SELECTED_LIST = 'ADD_DEVICE_TO_SELECTED_LIST';

export const GET_USER_INFO = 'GET_USER_INFO';
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const ALERT_POPED = 'ALERT_POPED';

// EVENT
export const SELECT_EVENT = 'SELECT_EVENT';
export const SET_CURRENT_EVENT = 'SET_CURRENT_EVENT';
export const FILTER_EVENTS = 'FILTER_EVENTS';
export const SET_MED_RECORD_NO = 'SET_MED_RECORD_NO';

// Schedule
export const SET_TODAY_SCHEDULE = 'SET_TODAY_SCHEDULE';
export const SET_CURRENT_SCHEDULE_BY_ID = 'SET_CURRENT_SCHEDULE_BY_ID';
export const SET_SCHEDULE_MED_LIST = 'SET_SCHEDULE_MED_LIST';
export const RESET_SCHEDULE = 'RESET_SCHEDULE';
export const SET_CURRENT_SCHEDULE_DIRECTLY = 'SET_CURRENT_SCHEDULE_DIRECTLY';




// WEBPACK FOOTER //
// ./src/vuex/mutation-types.js